import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from '../../shared/common/Loader';
import Breadcrumbs from '../../shared/common/@extended/Breadcrumbs';
import OrderTypeModal from '../../shared/common/OrderTypeModal';
import { useStore } from '../../stores/store';

import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

const DashboardLayout = observer(() => {
  const { pathname } = useLocation();
  const { menuMasterLoading } = useGetMenuMaster();
  const { commonStore } = useStore();
  const { isDirectDelivery, setIsDirectDelivery } = commonStore;
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {pathname !== '/apps/profiles/account/my-account' && <Breadcrumbs />}
          <Outlet />
          <Footer />
        </Box>
      </Box>

      <OrderTypeModal 
        open={isDirectDelivery === null} 
        onClose={() => setIsDirectDelivery(false)} 
        onSelect={(val) => setIsDirectDelivery(val)} 
      />
    </Box>
  );
});

export default DashboardLayout;
